import { render, staticRenderFns } from "./ProcessosInativos.vue?vue&type=template&id=5c91bc2a&"
import script from "./ProcessosInativos.vue?vue&type=script&lang=js&"
export * from "./ProcessosInativos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports